<template>
  <!-- Benutzermenü: nur Abmelden. Die Navigation zwischen den Bereichen steckt in der Seitenleiste. -->
  <div class="v2-user-menu bdd">
    <div class="bddbtn" :class="{ has: isOpen }">
      <button
        type="button"
        class="bddmain"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-haspopup="menu"
        @click="isOpen = !isOpen"
      >
        <i class="fas fa-user" aria-hidden="true" />
        <span>Menü</span>
      </button>
      <button type="button" class="bddcar" aria-label="Menü öffnen" @click="isOpen = !isOpen">▾</button>
    </div>

    <template v-if="isOpen">
      <div class="bdd-back" @click="isOpen = false" />
      <div class="bddmenu" role="menu">
        <div v-if="userName" class="bddhead">
          <span>{{ userName }}</span>
        </div>
        <button type="button" class="bdditem bdditem-btn v2-user-menu__item--logout" role="menuitem" @click="logout">
          <i class="fas fa-sign-out-alt" aria-hidden="true" />
          <span>Ausloggen</span>
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  userName: { type: String, default: '' }
});

const emit = defineEmits(['logout']);
const isOpen = ref(false);

function logout() {
  isOpen.value = false;
  emit('logout');
}
</script>
